import restUtils from "core/utils/rest";
import {
  BackendRoles,
  PaginatedPermissionRequest,
  PaginatedPermissions,
  PaginatedRoles,
  PaginatedRolesRequest,
  Roles,
  RolesPermissions,
} from "../model";

const UMAPI = "UserManagementApi";
const USER_ROLES = "user-roles";

class UserRoleStore {
  getUserRoles = async (payload: PaginatedRolesRequest) => {
    return await restUtils.call<PaginatedRoles>(
      UMAPI,
      USER_ROLES,
      "GET",
      payload
    );
  };

  getUserRoleById = async (id: any) => {
    const userRoles = await restUtils.call<RolesPermissions>(
      UMAPI,
      USER_ROLES + `/${id}`,
      "GET"
    );
    if (Array.isArray(userRoles?.backend_roles)) {
      userRoles.backend_roles = userRoles.backend_roles.map((r: any) => r?.id);
    }
    return userRoles;
  };

  createUserRole = async (payload: Roles) => {
    return await restUtils.call<any>(UMAPI, USER_ROLES, "POST", payload);
  };

  updateUserRole = async (id: any, payload: Roles) => {
    return await restUtils.call<any>(
      UMAPI,
      USER_ROLES + `/${id}`,
      "PUT",
      payload
    );
  };

  updateUserRolePermissions = async (id: any, payload: any) => {
    return await restUtils.call<any>(
      UMAPI,
      USER_ROLES + `/roles/update-permissions/${id}`,
      "PUT",
      payload
    );
  };

  getUserRolePermissions = async (payload: PaginatedPermissionRequest) => {
    return await restUtils.call<PaginatedPermissions>(
      UMAPI,
      USER_ROLES + "/roles/permissions",
      "GET",
      payload
    );
  };

  getUserBackendRole = async () => {
    return await restUtils.call<BackendRoles[]>(
      UMAPI,
      USER_ROLES + "/roles/backend-roles",
      "GET"
    );
  };
}

const userRoleStore = new UserRoleStore();
export default userRoleStore;
